import { TableCell } from '@/components/ui/table';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type SuggestedActionCellProps = {
  row: UnitOverviewRow;
};

export function SuggestedActionCell({ row }: SuggestedActionCellProps) {
  return (
    <TableCell wide justify="left">
      {row.suggestedAction ?? ''}
    </TableCell>
  );
}
